import type { Product } from "../../shared/types";

export type Basket = Record<string, number>;

export function sanitizeBasket(products: Product[], basket: Basket): Basket {
  const ids = new Set(products.map((product) => product.id));
  return Object.fromEntries(
    Object.entries(basket).filter(([id, quantity]) => ids.has(id) && Number.isSafeInteger(quantity) && quantity > 0),
  );
}

export function partitionCatalog(products: Product[], basket: Basket) {
  const selected: Product[] = [];
  const available: Product[] = [];
  for (const product of products) (basket[product.id] > 0 ? selected : available).push(product);
  return { selected, available };
}

export function changeBasketQuantity(basket: Basket, id: string, amount: number): Basket {
  const next = { ...basket, [id]: (basket[id] || 0) + amount };
  if (next[id] <= 0) delete next[id];
  return next;
}

export const basketCount = (basket: Basket) => Object.values(basket).reduce((sum, quantity) => sum + quantity, 0);

export function basketTotal(products: Product[], basket: Basket) {
  return products.reduce((sum, product) => sum + product.price_iqd * (basket[product.id] || 0), 0);
}
